import React, { useState, useEffect } from 'react';
import './Home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, faTwitter, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

import image2 from './images/reno3.png';
import image4 from './images/home3.svg';
import nano1 from './images/nano.png';
import nano2 from './images/nano2.png';
import nano3 from './images/nano4.svg';
import nano4 from './images/nano3.svg';
import nano5 from './images/nano5.svg';
import nano6 from './images/nano6.png';
import home2 from './images/home2.svg';

const images = [image2, home2, image4, nano1, nano2, nano3, nano4, nano5, nano6];

const Home = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3500);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="home-container">
            <div className="text-container">
                <h1 className="heading">
                    UnLock.....<br />
                    <span className='hi'>
                        <span className='letter' style={{ color: '#f28b82' }}>D</span>
                        <span className='letter' style={{ color: '#fbbc04' }}>e</span>
                        <span className='letter' style={{ color: '#fff475' }}>v</span>
                        <span className='letter' style={{ color: '#ccff90' }}>O</span>
                        <span className='letter' style={{ color: '#a7ffeb' }}>p</span>
                        <span className='letter' style={{ color: '#d7aefb' }}>s</span>
                    </span>
                    <br /> Your Guide to<br /> Streamlined <br />Development
                </h1>
                
                <div className="social-container">
                    <button className="acbutton">
                        <Link to="/login" className="tt">Get's Started!!</Link>
                        <FontAwesomeIcon icon={faTelegram} className="icon" />
                    </button>

                    <div className="set">
                        <a href="https://linkedin.com/in/shubhamsharmadevops☁️" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faLinkedin} />
                        </a>
                        <a href="https://x.com/Shubham_Dev_Ops" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faTwitter} />
                        </a>
                        <a href="https://github.com/Shubham-Sharma-sk" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faGithub} />
                        </a>
                    </div>
                </div>
            </div>

            <div className="image-container">
                <div className="imagescroll">
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`Slide ${index + 1} of DevOps presentation`}
                            style={{ opacity: currentIndex === index ? 1 : 0 }}
                        />
                    ))}
                </div>
            </div>

            {/* Circles */}
            <div className="circle p"></div>
            <div className="circle we"></div>
            <div className="circle uu"></div>
            <div className="circle wh"></div>
            <div className="circle ur"></div>
            <div className="circle urr"></div>
        </div>
    );
}

export default Home;